import type { RestaurantTagId } from '../../../../lib/graphql/scalars'

export type Tag = {
  facetKey: string
  label: string
}

export type TagCategory = {
  label: string
  children: Tag[]
}

export const anniversary: Tag = {
  facetKey: 'tag.tag_scene.369',
  label: '記念日',
}

export const birthday: Tag = {
  facetKey: 'tag.tag_scene.2859',
  label: '誕生日',
}

export const businessDinner: Tag = {
  facetKey: 'tag.tag_scene.372',
  label: '接待・会食',
}

export const nightView: Tag = {
  facetKey: 'tag.tag_scene.366',
  label: '夜景が綺麗',
}

export const scenes: TagCategory[] = [
  {
    label: 'シーン',
    children: [
      {
        facetKey: 'tag.tag_scene.368',
        label: 'デート',
      },
      {
        facetKey: 'tag.tag_scene.2863',
        label: '女子会',
      },
      businessDinner,
      {
        facetKey: 'tag.tag_scene.371',
        label: '飲み会',
      },
      {
        facetKey: 'tag.tag_scene.2864',
        label: '合コン',
      },
      {
        facetKey: 'tag.tag_scene.2862',
        label: '子連れで',
      },
      {
        facetKey: 'tag.tag_scene.370',
        label: 'ファミリーで',
      },
      {
        facetKey: 'tag.tag_scene.3555',
        label: '友人・知人と',
      },
    ],
  },
  {
    label: '目的',
    children: [
      anniversary,
      birthday,
      {
        facetKey: 'tag.tag_scene.3215',
        label: 'プロポーズ',
      },
      {
        facetKey: 'tag.tag_scene.373',
        label: '顔合わせ、結納',
      },
      {
        facetKey: 'tag.tag_scene.3222',
        label: '歓送迎会',
      },
      {
        facetKey: 'tag.tag_scene.2983',
        label: '同窓会',
      },
    ],
  },
  {
    label: '雰囲気',
    children: [
      nightView,
      {
        facetKey: 'tag.tag_scene.367',
        label: '景色が良い',
      },
      {
        facetKey: 'tag.tag_scene.377',
        label: '隠れ家',
      },
    ],
  },
]

export const foods: TagCategory[] = [
  {
    label: '食材',
    children: [
      {
        facetKey: 'tag.tag_ingredient.1733',
        label: '神戸牛',
      },
      {
        facetKey: 'tag.tag_genre.555',
        label: 'シャトーブリアン',
      },
      {
        facetKey: 'tag.tag_ingredient.14',
        label: '肉類',
      },
      {
        facetKey: 'tag.tag_ingredient.1830',
        label: 'フォアグラ',
      },
      {
        facetKey: 'tag.tag_ingredient.1877',
        label: '伊勢海老',
      },
      {
        facetKey: 'tag.tag_ingredient.1878',
        label: 'オマール海老',
      },
      {
        facetKey: 'tag.tag_ingredient.1882',
        label: 'ロブスター',
      },
      {
        facetKey: 'tag.tag_ingredient.143',
        label: '海老',
      },
      {
        facetKey: 'tag.tag_ingredient.145',
        label: '高級魚',
      },
      {
        facetKey: 'tag.tag_ingredient.1889',
        label: 'ウニ',
      },
      {
        facetKey: 'tag.tag_genre.3059',
        label: 'グルテンフリー',
      },
      {
        facetKey: 'tag.tag_ingredient.3137',
        label: 'トリュフ',
      },
      {
        facetKey: 'tag.tag_ingredient.16',
        label: '野菜',
      },
      {
        facetKey: 'tag.tag_ingredient.142',
        label: '蟹',
      },
      {
        facetKey: 'tag.tag_ingredient.209',
        label: '松茸',
      },
      {
        facetKey: 'tag.tag_ingredient.1864',
        label: '上海蟹',
      },
      {
        facetKey: 'tag.tag_ingredient.736',
        label: 'ふぐ',
      },
      {
        facetKey: 'tag.tag_ingredient.3258',
        label: '牡蠣',
      },
    ],
  },
  {
    label: '料理',
    children: [
      {
        facetKey: 'tag.tag_genre.84',
        label: 'シュラスコ',
      },
      {
        facetKey: 'tag.tag_genre.3014',
        label: 'ステーキ',
      },
      {
        facetKey: 'tag.tag_genre.606',
        label: 'フカヒレ料理',
      },
      {
        facetKey: 'tag.tag_genre.605',
        label: '北京ダック',
      },
      {
        facetKey: 'tag.tag_genre.814',
        label: 'ローストビーフ',
      },
      {
        facetKey: 'tag.tag_genre.770',
        label: '湯豆腐',
      },
      {
        facetKey: 'tag.tag_genre.1249',
        label: 'ホールケーキ',
      },
    ],
  },
  {
    label: '飲み物',
    children: [
      {
        facetKey: 'tag.tag_drink.238',
        label: 'スパークリングワイン',
      },
      {
        facetKey: 'tag.tag_drink.239',
        label: 'シャンパン',
      },
      {
        facetKey: 'tag.tag_drink.27',
        label: 'ワイン',
      },
      {
        facetKey: 'tag.tag_drink.29',
        label: '日本酒',
      },
    ],
  },
]

export const freeFlow3Hours: Tag = {
  facetKey: 'tag.tag_scene.2941',
  label: '3時間以上飲み放題',
}

export const afternoonTea: Tag = {
  facetKey: 'tag.tag_scene.2981',
  label: 'アフタヌーンティー',
}

export const others: TagCategory[] = [
  {
    label: 'その他',
    // PPG では「3時間以上飲み放題」は検索条件から非表示
    children: import.meta.env.VITE_MODE === 'ppg' ? [afternoonTea] : [afternoonTea, freeFlow3Hours],
  },
]

export const tagsMap = new Map<RestaurantTagId, Tag>()

function addToTagsMap(dst: Map<string, Tag>, ...src: TagCategory[][]) {
  for (const categories of src) {
    for (const category of categories) {
      for (const tag of category.children) {
        const md = /^tag\.tag_\w+\.(\d+)$/.exec(tag.facetKey)
        if (md === null) {
          continue
        }
        const id = md[1] as RestaurantTagId
        dst.set(id, tag)
      }
    }
  }
}
addToTagsMap(tagsMap, scenes, foods, others)
